<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  data: function () {
    return {
      supportPin: ''
    }
  },
  computed: {
    ...mapGetters({
      deviceId: 'getDeviceId'
    })
  },
  mounted() {
    this.$store.commit('startSessionTimer')
    document.addEventListener('click', this.$clickListener)
  },
  methods: {
    requestAccess() {
      axios({
        method: 'post',
        url: `/auth/collection_points/sign_in`,
        params: {
          device_id: this.deviceId,
          support_pin: this.supportPin
        }
      })
        .then((response) => {
          if (response.status == 200) {
            window.localStorage.setItem('support_session_token', response.data.token)
            this.$router.push('/support')
            // this.$isRemoteDevice ? this.$router.push("/support") : this.$router.push("/support/settings")
          }
        })
        .catch((error) => {
          let authError = Object.values(error.response.data.errors)[0][0]

          if (authError == 'Incomplete credentials') {
            this.$errorHumanized(null, this.$t('error.fillPin'))
          } else if (authError == 'Bad credentials') {
            this.$errorHumanized(null, this.$t('error.wrongPin'))
          } else {
            this.$errorHumanized(error)
          }
        })
    }
  }
}
</script>

<template lang="pug">
.route-view
  form(@submit.prevent="requestAccess")
    .font-weight-bold.text-center.mb-4 {{ $t('session.supportAuthorization.label') }}
    input.form-control.mb-4(
      type="number"
      :placeholder="$t('session.supportAuthorization.placeholder')"
      v-model="supportPin"
      @focus="$slideUp()"
      @blur="$slideDown()"
    )
    button.btn.btn-block.btn-primary.text-white(
      type="submit"
      @touchend.stop.prevent="requestAccess"
    ) OK
</template>

<style scoped lang="scss">
.route-view {
  display: flex;
  align-items: center;
  justify-content: center;
}
form {
  width: 20vw;
  margin-bottom: 15rem;
  input {
    -webkit-text-security: disc;
  }

  @media (max-width: 991.98px) {
    width: calc(100vw - 40px);
  }
}
</style>
